// extracted by mini-css-extract-plugin
export var animation = "Header-module--animation--L2Mcg";
export var container = "Header-module--container--YCogH";
export var fadeIn = "Header-module--fadeIn--WaL5q";